import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { handleSheetBack } from '../utils/bottomSheetBackStack';

/**
 * Hook to enable iOS-style swipe-back gesture in Capacitor apps.
 * This integrates with the hardware back button on Android and
 * enables programmatic back navigation that works with gestures.
 */
export const useSwipeBackGesture = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only run on native platforms
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    const handleBackButton = () => {
      // If any bottom sheet is open, close the topmost one instead of navigating.
      if (handleSheetBack()) return;

      // Define routes where back button should exit the app
      const exitRoutes = ['/', '/search', '/trending', '/profile', '/notifications'];

      if (exitRoutes.includes(location.pathname)) {
        // On main routes, exit the app
        CapacitorApp.exitApp();
      } else {
        // On other routes, navigate back
        navigate(-1);
      }
    };

    // Listen for hardware back button (Android) and back swipe gesture (iOS)
    const listener = CapacitorApp.addListener('backButton', handleBackButton);

    return () => {
      listener.remove();
    };
  }, [navigate, location.pathname]);
};
